import axios from "axios";

axios.defaults.baseURL = "";
axios.defaults.timeout = 10000;

axios.interceptors.response.use(
  resolve => {
    return Promise.resolve(resolve.data);
  },
  error => {
    return Promise.reject(error);
  }
);

export { axios };
